import React, { useState, useEffect } from 'react';
import { Field } from "react-final-form";
import { injectIntl } from "react-intl";
import {connect} from "react-redux";
import {compose} from "redux";
import Input from "../../components/Input/Input";

import ControlWrapper from "../ControlWrapper/ControlWrapper";

const CustomInput = ({
    input: { name, ...inputProps },
    input,
    formatMessage,
    setTouched,
    placeholder,
    type,
    errors,
    label,
    customTouched,
    disabled,
    ...meta
}) => {
    // Ensure autoComplete is set based on field type/name
    let autoComplete;
    if (name === 'identifier' || name === 'email' || type === 'email') {
        autoComplete = 'username';
    } else if (name === 'password' && type === 'password') {
        autoComplete = 'current-password';
    }

    return (
        <>
            <ControlWrapper
                label={label}
                name={name}
                customTouched={customTouched}
                error={meta.meta.error}
                touched={meta.meta.touched}
            >
                <Input
                    {...inputProps}
                    {...meta}
                    name={name}
                    type={type}
                    autoComplete={autoComplete}
                    onFocus={setTouched.bind(true)}
                    disabled={disabled}
                    placeholder={placeholder && formatMessage({ id: placeholder })}
                />
            </ControlWrapper>
        </>
    );
};

const InputField = ({
    name,
    errors,
    intl: { formatMessage },
    placeholder,
    type,
    label,
    disabled,
    ...props
}) => {
    const [ customTouched, setTouched ] = useState(false);

    useEffect(() => {
        setTouched(false);
    }, [errors]);

    return (
    <Field
        component={CustomInput}
        name={name}
        placeholder={placeholder}
        type={type}
        label={label}
        formatMessage={formatMessage}
        customTouched={customTouched}
        setTouched={setTouched}
        errors={errors}
        disabled={disabled}
        {...props}
    />
)};

export default compose(
    connect(
        ({ errors }) => ({ errors }),
        {}),
    injectIntl
)(InputField);
